import { FirebaseApp, initializeApp } from 'firebase/app';
import { getAuth, signInAnonymously, connectAuthEmulator } from 'firebase/auth';
import { getAnalytics, logEvent as firebaseLogEvent } from 'firebase/analytics';
import type { Analytics } from 'firebase/analytics';
import {
  getFirestore,
  connectFirestoreEmulator,
  collection,
  query,
  orderBy,
  limit,
  getDocs,
  addDoc,
  serverTimestamp,
} from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyB8_rXy8PE_ICtcjkIc3uOD5GLo9S0gtGg",
  authDomain: "tetris-b6e42.firebaseapp.com",
  projectId: "tetris-b6e42",
  storageBucket: "tetris-b6e42.firebasestorage.app",
  messagingSenderId: "401211131996",
  appId: "1:401211131996:web:bea9e99488a370d06c3e99",
  measurementId: "G-KQEHVPM7MM"
};

const app: FirebaseApp = initializeApp(firebaseConfig);
// Initialize anonymous auth to satisfy security rules that require auth
const auth = getAuth(app);
// Point to Auth emulator in development
if (window.location.hostname === 'localhost') {
  connectAuthEmulator(auth, 'http://localhost:9099');
}
// Start anonymous login and export the promise
export const signInPromise =
  signInAnonymously(auth).catch((err) => console.error('Anonymous auth failed:', err));
const db = getFirestore(app);
// Point Firestore to emulator in development
if (window.location.hostname === 'localhost') {
  connectFirestoreEmulator(db, 'localhost', 8080);
}
// Initialize Analytics (disabled on localhost)
// Analytics instance (only initialized when not localhost)
// Analytics instance (only initialized when not localhost)
let analytics: Analytics | null = null;
if (window.location.hostname !== 'localhost') {
  analytics = getAnalytics(app);
}

/**
 * Log a custom analytics event.
 * @param eventName The name of the event.
 * @param params Optional parameters to log with the event.
 */
export function logEvent(eventName: string, params?: Record<string, any>) {
  // Debug log for development
  console.debug('[Analytics]', eventName, params || {});
  try {
    if (analytics) {
      firebaseLogEvent(analytics, eventName, params);
    }
  } catch (err) {
    console.warn('[Analytics] logEvent failed:', err);
  }
}

export interface HighScore {
  name: string;
  score: number;
  timestamp: any;
}

/**
 * Fetch top high scores ordered by score descending.
 * @param limitNumber number of scores to fetch (default 10)
 */
/**
 * Fetch top high scores ordered by score descending.
 * @param limitNumber number of scores to fetch (default 5)
 */
export async function getHighScores(limitNumber = 5): Promise<HighScore[]> {
  const scoresRef = collection(db, 'highscores');
  const q = query(scoresRef, orderBy('score', 'desc'), limit(limitNumber));
  const querySnapshot = await getDocs(q);
  const scores: HighScore[] = [];
  querySnapshot.forEach((doc) => {
    const data = doc.data();
    scores.push({
      name: data.name,
      score: data.score,
      timestamp: data.timestamp,
    });
  });
  return scores;
}

/**
 * Submit a new high score.
 * @param name player name
 * @param score player score
 */
export async function submitHighScore(name: string, score: number): Promise<void> {
  const scoresRef = collection(db, 'highscores');
  await addDoc(scoresRef, {
    name,
    score,
    timestamp: serverTimestamp(),
  });
}